import React from 'react'
import { bca, location, bankmandiri, phone, time } from '../../assets'
import { socialMedia } from '../../constants'

function Footer() {
  return (
    <footer id='footer' style={{backgroundColor: "#222"}}>
      <div className="container text-center text-light">
        <div className="d-flex justify-content-center gap-5">
          {
            socialMedia.map(social => {
              return(
                <a href={social.link} className="text-decoration-none text-light" key={social.id} target="_blanks">
                  <img src={social.icon} alt={social.id} className="mb-2" />
                  <p>{social.name}</p>
                </a>
              )
            })
          }
        </div>

        <div className="row my-5">
          <h4 className='mb-3'>Black Canyon Transport - Rental Mobil Termurah dan Berkualitas Palu</h4>
          <p className='m-0'>Black Canyon Transport adalah sebuah usaha yang bergerak di bidang jasa transportasi. Jasa yang diberikan adalah dengan menyewakan mobil untuk konsumen yang memerlukan mobil untuk keperluan keberangkatan baik didalam maupun keluar daerah. Rental mobil termurah dan berkualitas di Kota Palu. Menyediakan berbagai pilihan unit mobil mulai dari Avanza, Agya, Brio, Ertiga, Innova Reborn, Rush, Hilux, Alphard, Luxury Car dan berbagai pilihan lainnya</p>
          <p className='color-black m-0'>Rental mobil palu, Rental mobil di kota palu, Rental mobil murah kota palu, Sewa mobil di kota palu, Sewa mobil palu, Black Canyon Transport</p>
        </div>

        <div className="row g-5">
          <div className="col-12 col-md-4 text-start">
            <h5 className='mb-4'>Hubungi Kami</h5>
            <ul type="none" className='p-0 m-0'>
              <div className='d-flex align-items-center gap-3'>
                <img src={time} alt="time" width="24px" height="24px" />
                <li className='mb-2'>Jam Operasional: Setiap Hari pukul 06.00 s/d 24.00 WITA</li>
              </div>
              <div className='d-flex align-items-center gap-3'>
                <img src={phone} alt="time" width="24px" height="24px" />
                <li className='mb-2'>0852-4132-9911</li>
              </div>
              <div className='d-flex align-items-center gap-3'>
                <img src={location} alt="time" width="24px" height="24px" />
                <li className='mb-2'>Jl. Prof. Moh Yamin No. 38B Kel. Birobuli utara. Kec Palu Selatan. Kota Palu</li>
              </div>
            </ul>
          </div>
          <div className="col-12 col-md-4 text-start text-md-center">
            <h5 className='mb-4'>Info</h5>
            <ul type="none" className='p-0 m-0'>
              <li className='mb-2'><a href="#produk" className='text-decoration-none text-light'>Sewa Mobil</a></li>
              <li className='mb-2'><a href="#testimoni" className='text-decoration-none text-light'>Testimoni</a></li>
              <li className='mb-2'><a href="#clients" className='text-decoration-none text-light'>Sponsor</a></li>
              <li className='mb-2'><a href="#cta" className='text-decoration-none text-light'>Hubungi Kami</a></li>
            </ul>
          </div>
          <div className="col-12 col-md-4 text-start text-md-center">
            <h5>Pembayaran</h5>
            <img src={bca} alt="bca" className='mb-2'/>
            <img src={bankmandiri} alt="mandiri" width="240px" height="80px" className='rounded-2'/>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer